import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import logo from "../../../assets/images/others/host-side-images/logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../useHooks";
import { errorToaster } from "../../../utils/helpers/common/alert-service";

type FormValues = {
  password: string;
  confirmPassword: string;
};

const ResetPassword: React.FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();
  const { resetPassword } = useAuth();

  const location = useLocation();
  const email = location.state?.email;
  const otp = location.state?.otp;

  console.log(otp);
  console.log(email);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const onSubmit = async (data: FormValues) => {
    if (data.password !== data.confirmPassword) {
      return errorToaster("Passwords do not match");
    }

    await resetPassword({ email, otp, password: data.password });
  };

  const validatePassword = (password: string) => {
    const errors: string[] = [];

    if (password.length < 8) {
      errors.push("at least 8 characters");
    }
    if (!/[A-Z]/.test(password)) {
      errors.push("one uppercase letter");
    }
    if (!/[a-z]/.test(password)) {
      errors.push("one lowercase letter");
    }
    if (!/\d/.test(password)) {
      errors.push("one number");
    }
    if (!/[\W_]/.test(password)) {
      errors.push("one special character");
    }
    // if (/\s/.test(password)) {
    //   errors.push("no spaces");
    // }

    return errors.length > 0
      ? `Password must include at least ${errors.join("/")}`
      : true;
  };

  return (
    <div className="w-full h-screen flex flex-col p-4 sm:p-6 lg:px-8 xl:px-10 lg:py-6">
      {/* Logo */}
      <div className="flex justify-center my-6">
        <img src={logo} alt="logo" className="h-20" />
      </div>

      {/* Form Container */}
      <div className="flex-1 flex  justify-center">
        <div className="w-full">
          <div className="w-full mb-6">
            <h1 className="text-3xl font-medium text-blackie">
              Reset Password
            </h1>
            <p className="text-lg text-labelTextColor mt-2">
              Enter your new password and confirm it to complete the reset
              process.
            </p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="mt-6">
            {/* Password Input */}
            <div className="flex flex-col gap-1">
              <div className="flex items-center justify-between">
                <label className="custom-label">New Password</label>
                <div
                  className="cursor-pointer text-sm flex items-center text-label"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <>
                      <AiFillEyeInvisible size={18} className="mr-1" />
                      <span>Hide</span>
                    </>
                  ) : (
                    <>
                      <AiFillEye size={18} className="mr-1" />
                      <span>Show</span>
                    </>
                  )}
                </div>
              </div>

              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                {...register("password", {
                  required: "Password is required",
                  minLength: {
                    value: 8,
                    message: "Password must be at least 8 characters long",
                  },
                  validate: {
                    noLeadingTrailingSpaces: (value) =>
                      !/\s/.test(value) || "Password does not contain spaces.",
                    validatePassword,
                  },
                })}
                className="custom-input"
              />

              {errors.password && (
                <span className="text-red-500 text-sm">
                  {errors.password.message}
                </span>
              )}
            </div>

            {/* Confirm Password Input */}
            <div className="flex flex-col gap-1 mt-4">
              <div className="flex items-center justify-between">
                <label className="custom-label">Confirm Password</label>
                <div
                  className="cursor-pointer text-sm flex items-center text-label"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <>
                      <AiFillEyeInvisible size={18} className="mr-1" />
                      <span>Hide</span>
                    </>
                  ) : (
                    <>
                      <AiFillEye size={18} className="mr-1" />
                      <span>Show</span>
                    </>
                  )}
                </div>
              </div>

              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm your password"
                {...register("confirmPassword", {
                  required: "Confirm Password is required",
                })}
                className="custom-input"
              />

              {errors.confirmPassword && (
                <span className="text-red-500 text-sm">
                  {errors.confirmPassword.message}
                </span>
              )}
            </div>

            {/* Submit Button */}
            <div className="flex justify-start flex-col gap-2 mt-4">
              <button
                type="submit"
                className="lg:h-[64px] px-6 py-3 text-xl bg-primaryBlueBg rounded-full text-white w-fit sm:w-1/2"
              >
                Reset Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
